/**
 * Authentication constants — admin frontend
 *
 * Tokens stored in httpOnly cookies (par admin: kaive_admin_at / kaive_admin_rt).
 * Paths são relativos — base URL definida em VITE_API_BASE_URL.
 */

export const AUTH_ENDPOINTS = {
  ME: '/auth/me',
  LOGIN: '/auth/admin/login',
  LOGOUT: '/auth/admin/logout',
  REFRESH: '/auth/refresh',
  CHANGE_PASSWORD: '/auth/me/password',
} as const;

/**
 * `/auth/admin/login` exige `userType=admin_user` no body — embora o service
 * já filtre `role=super_admin` no SELECT, o schema Zod do endpoint genérico
 * exige o campo. Mantemos `admin_user` aqui pra compatibilidade do schema.
 */
export const ADMIN_USER_TYPE = 'admin_user' as const;

export const SUPER_ADMIN_ROLE = 'super_admin' as const;

/**
 * Allowlist de e-mails autorizados a usar o botão "Impersonar" na listagem
 * de empresas. Gate puramente visual — o backend valida apenas `requireSuperAdmin`.
 */
export const IMPERSONATION_ALLOWED_EMAILS: readonly string[] = [
  'marlon.savian@gmail.com',
];

export function canImpersonate(email?: string | null): boolean {
  if (!email) return false;
  return IMPERSONATION_ALLOWED_EMAILS.includes(email);
}
